import queryString from 'query-string';
import * as routes from '../../../../universal/main/mainRoutes';
import * as actionTypes from '../mainActionTypes';
import * as origins from '../../../../universal/consts/origins';
import { domainPrices } from '../../../consts/domainsPrices';

export default (businessNameGenerator, history, basePath, logoUrlGenerator) => (/* store */) => next => async action => {
  try {
    const { type, payload } = action;
    const getDomainPrice = domainName => {
      let price = '';
      const domainSuffix = domainName.split('.')[1];
      if (domainPrices[domainSuffix]) {
        price = domainPrices[domainSuffix];
      }
      return price;
    };

    const getDomainsUrlV3 = async (domainName = '', referral = '', screenType = 'desktop', NavigateToMarketingLP) => {
      if (NavigateToMarketingLP) {
        if (screenType === 'desktop') {
          return `https://www.wix.com/mystunningwebsites/domain-solutions?biz_name=${domainName.trim()}&referralAdditionalInfo=${referral}`;
        } else {
          return `https://www.wix.com/mystunningwebsites/domain-name?&biz_name=${domainName.trim()}&referralAdditionalInfo=${referral}`;
        }
      } else {
        const [domainData, userIsLoggedIn] = await Promise.all([
          businessNameGenerator.getDomainAvailability(domainName),
          businessNameGenerator.checkIfUserIsLoggedIn()
        ]);
        const { domain, available } = domainData;
        const domainPrice = getDomainPrice(domainName);

        if (userIsLoggedIn) {
          if (available) {
            return `https://www.wix.com/new/domain?domain=${domain.trim()}&price=${domainPrice}&referralAdditionalInfo=${referral}`;
          } else {
            return `https://www.wix.com/domain/names?domainName=${domain.trim()}&referralAdditionalInfo=${referral}`;
          }
        } else {
          if (available) {
            // eslint-disable-next-line max-len
            return `https://users.wix.com/signin?loginDialogContext=signup&redirectTo=https://www.wix.com/wearepages/lior-blank?domain=${domain.trim()}%26price=${domainPrice}&forceRender=true&referralAdditionalInfo=${referral}`;
          } else {
            // eslint-disable-next-line max-len
            return `https://users.wix.com/signin?loginDialogContext=signup&redirectTo=https://www.wix.com/domain/names?domainName=${domain.trim()}&overrideLocale=en&forceRender=true&referralAdditionalInfo=${referral}`;
          }
        }
      }
    };

    const changeRoute = newRoute => {
      let querySeperator = '?';
      const currentSearch = queryString.parse(window.location.search);
      if (newRoute.indexOf('?') !== -1) {
        querySeperator = '&';
      }
      history.push(`${newRoute}${querySeperator}${queryString.stringify(currentSearch)}`);
    };
    // const isChromeIOS = environment.isChrome && environment.isIOSdevice;

    switch (type) {
      case actionTypes.GO_TO_BUSINESS_NAME: {
        changeRoute(routes.COMPANY_DETAILS);
        break;
      }
      case actionTypes.GO_TO_TAGS_SELECTOR: {
        changeRoute(routes.TAGS);
        break;
      }
      case actionTypes.SKIP_AND_GO_TO_TAGS_SELECTOR: {
        changeRoute(routes.COMPANY_DETAILS);
        break;
      }
      case actionTypes.GO_TO_PURPOSE_PAGE:
        changeRoute(routes.NAMESLIST);
        break;
      case actionTypes.SKIP_AND_GO_TO_PURPOSE_PAGE:
        changeRoute(routes.NAMESLIST);
        break;
      case actionTypes.GO_TO_ROUTE:
        changeRoute(payload);

        break;
      case actionTypes.NAVIGATE_TO_LOGO_EDITOR:
        {
          const { selectedZoeTemplate, companyDetails } = payload;
          const url = logoUrlGenerator.getLogoEditorUrl(selectedZoeTemplate, companyDetails, origins.BUSINESS_NAME_GENERATOR);
          window.location.href = url;
        }
        break;
      case actionTypes.GO_TO_BNG_LIST:
        changeRoute(routes.NAMESLIST);

        break;
      case actionTypes.GO_TO_DOMAIN:
        {
          const url = logoUrlGenerator.getPremiumDomainsUrl(payload, origins.BUSINESS_NAME_GENERATOR);
          window.open(url, '_blank');
          // window.location.href = url;
        }
        break;
      case actionTypes.GO_TO_DOMAIN_PAGE_V3:
        {
          const { domainName, screenType, NavigateToMarketingLP } = payload;
          const url = await getDomainsUrlV3(domainName, origins.BUSINESS_NAME_GENERATOR, screenType, NavigateToMarketingLP);
          // window.open(url, '_blank');
          const newWindow = window.open(url, '_blank');
          if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
            window.location.href = url;
          }
        }
        break;
      case actionTypes.NAVIGATE_TO_CREATE_NEW_WEBSITE:
        {
          const url = logoUrlGenerator.getNewWebsiteUrl(origins.BUSINESS_NAME_GENERATOR);
          window.location.href = url;
        }
        break;
      case actionTypes.NAVIGATE_TO_LOGO_ONBOARDING:
        {
          const { industry, tags, companyDetails } = payload;
          const url = logoUrlGenerator.getLogoOnboardingUrl(companyDetails, industry, tags, origins.BUSINESS_NAME_GENERATOR);
          window.location.href = url;
        }
        break;

      default:
        break;
    }
  } catch (error) {
    console.error(error);
  }
  next(action);
};
